module.exports = __webpack_public_path__ + "static/media/socialmediaMarketing.1e8e1b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Mtech/socialmediaMarketing.jpg
// module id = 333
// module chunks = 0